import * as $ from 'jquery';
import 'custom-event-polyfill'
import { Header } from './components/header';
import { MobileMenu } from './components/mobile-menu';
import { Effects } from './components/effects';
import { ModalWindowFullScreen } from './components/modal-window-fullscreen';
import { SomethingSlider } from './components/something-slider/'
import {
    initMaskedInput,
    initPlaceholders
} from './components/form';

import { Selects } from './components/form';
import { SectionsSelect } from "./components/residential-complex";
import FloorSelect from "./components/residential-complex/floor-select";
import RoomSelect from "./components/residential-complex/room-select";
import { InfrastructureMap } from "./components/location-map";
import { ContactMap } from "./components/contacts-map";
import ApartmentView from "./components/residential-complex/apartment-view";
import { InitReserveForm } from "./components/reserve-form";
import ContactsMap from "./components/map";
import lozad from "lozad";

$(function () {
    // скрываем прелоадер страницы если он есть
    const $pagePreloader = $('#page_preloader');
    const $spinner = $('.select-room-button');
    const $bgBlockForAnimation = $('#forAnimation');

    //Отключение блюра для первой сессии
    if (window.location.href == 'https://voznesensky.internetlab.ru/' && sessionStorage.getItem("isNewSession") == null) {
        $('html').removeClass('bg-blur-page');
    }

    $('html').addClass('bg-blur-off');

    //Показываем эффекты на главной картинке, заголовке и ссылкам только если это новая сессия
    if (sessionStorage.getItem("isNewSession") == null) {
        $bgBlockForAnimation
            .addClass('section-bg');

        $bgBlockForAnimation
            .find('.inner-content')
            .addClass('animate-block');

        $bgBlockForAnimation
            .find('.buttons')
            .addClass('not-effect');

        $bgBlockForAnimation
            .find('h2')
            .addClass('not-effect');

        setTimeout(() => {
            $bgBlockForAnimation
                .find('.buttons')
                .addClass('effect-only-opacity-2');

            $bgBlockForAnimation
                .find('h2')
                .addClass('effect-only-opacity-1');
        }, 5500)
    }

    sessionStorage.setItem("isNewSession", "yea");

    //Получение ширины прокрутки
    let div = document.createElement('div');
    div.style.overflowY = 'scroll';
    div.style.width = '50px';
    div.style.height = '50px';
    document.body.append(div);
    let scrollWidth = div.offsetWidth - div.clientWidth;
    div.remove();

    /* 
    скрываем overflow для body, пока идёт анимация прелоадера и сдвигаем body
     со спиннером для того, чтобы изображение не прыгало
    */

    $('body, .body').css('overflow', 'hidden');
    // $('body').css('padding-right', `${scrollWidth}px`);
    // $spinner.css('margin-right', `${scrollWidth}px`);

    if ($pagePreloader.length) {
        $pagePreloader.addClass('animate-start');

        setTimeout(() => {

            hidePreloaderPage();

            /* 
            overflow=auto для body, когда анимация закончилась и
            убираем новые стили для body и спиннера
            */

            $('body, .body').css('overflow', 'auto');
            // $('body').css('padding-right', '0');
            // $spinner.css('margin-right', '0');

            initScripts();
            $pagePreloader.remove();
        }, 5500);

    } else {
        /* 
            overflow=auto для body, когда анимация закончилась и
            убираем новые стили для body и спиннера
        */

        $('body').css('overflow-x', 'auto');
        $('body').css('overflow-y', 'auto');
        $('body').css('padding-right', '0');
        $spinner.css('margin-right', '0');

        hidePreloaderPage();
        initScripts();
    }

    //скрываем пункты меню и хедера, если мы находимся на этой же странице
    // (п - для страницы "О проекте" в хедере и меню скрывается ссылка "О проекте")

    if(window.location.href === 'https://voznesensky.info/about/'){
        $('.header-content').find('a[href="/about/"]').hide();
        $('#mobile_menu').find('a[href="/about/"]').hide();

    }else if(window.location.href === 'https://voznesensky.info/choise/'){
        $('.header-content').find('a[href="/choise/"]').hide();
        $('#mobile_menu').find('a[href="/choise/"]').hide();

    }else if(window.location.href === 'https://voznesensky.info/contacts/'){
        $('.header-content').find('a[href="/contacts/"]').hide();
        $('#mobile_menu').find('a[href="/contacts/"]').hide();
    }


    function hidePreloaderPage() {
        $('.preloader-page').removeClass('preloader-page');
        setTimeout(() => {
            $('.preloader-page-pxl').remove();
        }, 600);
    }
});

// инициализация скриптов
function initScripts() {
    // инициализация функционала хедера
    //new Header();

    updateViewportHeight();

    // инициализация мобильного меню
    const mobileMenu = new MobileMenu();
    $('body').on('click', '.mobile-menu-toggle-button', function () {
        mobileMenu.toggle();
        return false;
    });

    $(window).on('resize', () => {
        updateViewportHeight();
    });

    const observer = lozad('.lozad', {
        load: function (el) {
            if (el.dataset.background) {
                $(el).css('background-image', 'url(' + el.dataset.background + ')');
            }
            if (el.dataset.src) {
                el.src = el.dataset.src
            }

            el.classList.add('fade')
        }
    });
    observer.observe()

    // эффекты
    new Effects();

    // слайдер
    new SomethingSlider();

    // выбор секции на странице ЖК
    new SectionsSelect($('#rc_sections'));

    new FloorSelect($('#rc_floors'));

    new RoomSelect($('#rc_floor'));

    //Горизонатальный блок с фильтром

    new ApartmentView($('#apartment_view'))

    //Форма заявки на бронирование
    new InitReserveForm();

    //Карта для страницы контактов
    new ContactsMap();

    //Карта инфраструктуры
    new InfrastructureMap();

    new ContactMap();

    // Инициализация плейсхолдеров и масок
    initMaskedInput();
    initPlaceholders();

    // кноики показать ещё
    $('body').on('click', '[data-show_more_button]', function () {
        const id = $(this).attr('data-show_more_button');
        $(`[data-show_more="${id}"]`).removeClass('hide');
        $(this).remove();
        return false;
    });

    //плавный скролл к якорю
    $('a[href*="#"]').click(function () {
        let $page = $('html, body');

        $page.animate({
            scrollTop: $($.attr(this, 'href')).offset().top - 100
        }, 500);
        return false;
    });

    // модальные окна фулскрин
    const modalWindow = new ModalWindowFullScreen();

    if ($('[data-modal="main_info_modal"]').length && !sessionStorage.getItem('promo-modal')) {
        modalWindow.open('main_info_modal', 'open-modal-fade-effect')
        sessionStorage.setItem('promo-modal', 'show')
    }

    const selects = new Selects({ searchEnabled: false, itemSelectText: '' });
}

const updateViewportHeight = () => {
    if ($(document).width() < 1000) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight - 64}px`);
    } else {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight - 96}px`);
    }
};
